import { render, staticRenderFns } from "./AdminTierCreate.vue?vue&type=template&id=025dfbdf&"
import script from "./AdminTierCreate.vue?vue&type=script&lang=js&"
export * from "./AdminTierCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports